module.exports = __webpack_public_path__ + "static/media/city-placeholder.9b980bc6.jpg";